import { use } from "react"
import { useCallback, useEffect, useState } from "react"

// Den här hook:en håller koll på de företag man matchar med i MatchCompany.jsx
const useCompanySwipeStack = (allCompanies, favoriteCompanies) => {
    const [availableCompanies, setAvailableCompanies] = useState([])
    // Hämta rejected companies från local storage
    const [rejectedCompanies, setRejectedCompanies] = useState(() => {
        const saved = localStorage.getItem("rejectedCompanies")
        return saved ? JSON.parse(saved) : []
    })
    const [currentIndex, setCurrentIndex] = useState(0)

    // Spara rejected companies i local storage när de ändras
    useEffect(() => {
        localStorage.setItem(
            "rejectedCompanies",
            JSON.stringify(rejectedCompanies),
        )
    }, [rejectedCompanies])

    // Initialiserar eller laddar om stacken
    const refreshStack = useCallback(() => {
        // Filtrera bort avvisade och gollade företag, samt gör slumpmässig ordning
        const available = allCompanies
            .filter(
                (company) =>
                    !favoriteCompanies.some(
                        (fav) => fav.monternummer === company.monternummer,
                    ),
            )
            .filter(
                (company) =>
                    !rejectedCompanies.some(
                        (rejected) =>
                            rejected.monternummer === company.monternummer,
                    ),
            )
            .sort(() => Math.random() - 0.5)
        setAvailableCompanies(available)
        setCurrentIndex(0)
    }, [allCompanies, rejectedCompanies, favoriteCompanies])

    // Kör vid mount och när refreshStack beroenden ändras (rejectedCompanies, favoriteCompanies, allCompanies)
    useEffect(() => {
        refreshStack()
    }, [refreshStack])

    const handleSwipe = useCallback(
        (liked) => {
            const currentCompany = availableCompanies[currentIndex]
            if (!currentCompany) return
            if (!liked) {
                setRejectedCompanies((prev) => [...prev, currentCompany])
            }
            setCurrentIndex((prev) => prev + 1)
        },
        [currentIndex, availableCompanies],
    )

    // Funktion för att rensa rejected companies
    const clearRejectedCompanies = useCallback(() => {
        setRejectedCompanies([])
        localStorage.removeItem("rejectedCompanies")
    }, [])

    return {
        currentCompany: availableCompanies[currentIndex],
        handleSwipe,
        refreshStack,
        clearRejectedCompanies,
        isStackEmpty: currentIndex >= availableCompanies.length,
        canRefresh:
            currentIndex >= availableCompanies.length &&
            rejectedCompanies.length > 0,
        allCompaniesLiked:
            currentIndex >= availableCompanies.length &&
            rejectedCompanies.length === 0,
    }
}

export default useCompanySwipeStack
